import React from 'react';
import Slider from 'react-slick'; // Import Slider from react-slick
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css'; 


// Review data (7 reviews)
const reviews = [
  "Dr. Raj Kumar Sharma is an exceptional urologist! His expertise saved my life.",
  "Best kidney doctor in Lucknow! Highly recommend Dr. Sharma for anyone suffering from kidney issues.",
  "My experience with Dr. Raj Kumar Sharma was very positive. He made me feel at ease during the treatment.",
  "I had a successful kidney transplant, thanks to Dr. Sharma's expertise. He's the best in Lucknow!",
  "Dr. Raj Kumar Sharma's team provided excellent care. The treatment was effective and efficient.",
  "Dr. Sharma is very knowledgeable and compassionate. I felt comfortable throughout the treatment process.",
  "I am very grateful to Dr. Sharma for his care and attention. He made a real difference in my health."
];

const Review = () => {
  // Slider settings for smooth automatic sliding
  const settings = {
    dots: true, // Enable dot navigation
    infinite: true, // Infinite scrolling
    speed: 500, // Speed of sliding
    slidesToShow: 1, // Only show one review at a time
    slidesToScroll: 1, // Scroll 1 slide at a time
    autoplay: true, // Enable auto slide
    autoplaySpeed: 3000, // Auto slide interval (in milliseconds)
  };

  return (
    <div className="review-container">
      <h2>Dr. Raj Kumar Sharma | Best Kidney and Urologist in Lucknow</h2>
      <h3>Patient Reviews from the Web</h3>

      {/* Slick Slider */}
      <Slider {...settings}>
        {reviews.map((review, index) => (
          <div key={index} className="review-item">
            <p>{review}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Review;
